import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupRestrictedActionsOffAllContentProps } from './msg-group-restricted-actions-off-all-content';
import { MsgGroupRestrictedActionsOffAllContent } from './msg-group-restricted-actions-off-all-content';

export interface MsgGroupRestrictedActionsOffAllProps
  extends MsgGroupRestrictedActionsOffAllContentProps {}

export const MsgGroupRestrictedActionsOffAll = memo(function MsgGroupRestrictedActionsOffAll({
  message,
}: MsgGroupRestrictedActionsOffAllProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupRestrictedActionsOffAllContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
